import { ReactComponent as DashedCircleIcon } from "../../../assets/dashed-border-circle.svg";
import { ReactComponent as BlueTickIcon } from "../../../assets/blue-tick.svg";
import { ReactComponent as TicketIcon } from "../../../assets/ticket-icon.svg";
import { NavLink } from "react-router-dom";

const EventBookingConfirmation = () => {
  return (
    <div className="my-4 p-[10px] sm:!p-[12px] max-w-7xl bg-white rounded-[10px] min-h-[600px] flex flex-col items-center justify-center">
      <div className="flex flex-col items-center">
        <div className="w-[120px] relative h-[120px] flex items-center bg-[#F5F6FA] justify-center rounded-full">
          <DashedCircleIcon className="absolute left-2 top-2 flex items-center justify-center" />
          <span className="w-[120px] h-[120px] rounded-full absolute left-2 top-2 flex items-center justify-center">
            <BlueTickIcon />
          </span>
        </div>

        <h1 className="heading text-[25px] xs:text-[30px] mt-[25px] mb-2  text-dark-blue">
          Tickets booked!
        </h1>
        <p className="text-[#626570] xs:text-base text-sm text-center w-full">
          An email with Tickets booking details is sent to the respective
          emails.
        </p>
      </div>

      <div className="min-h-[283px] mt-[43px] flex  rounded-[20px] p-[10px] xs:p-[16px] bg-[#F5F6FA] w-full xl:w-[858px] flex-wrap gap-[20px]">
        <img
          src="/event1.png"
          alt=""
          className="h-[200px] w-full sm:h-[300px] xl:h-[251px] xl:w-[400px] object-cover  rounded-[14px]"
        />
        <div className="h-full">
          <h1 className="text-[20px] text-dark-blue font-semibold mb-[22px] ">
            Green Day 2025 Live in Expo City Dubai
          </h1>
          <div className="flex gap-1 ">
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.6581 11.8741L3.11964 12.0664L2.6581 11.8741ZM2.10255 13.2074L2.56408 13.3997L2.10255 13.2074ZM13.8974 13.2074L13.4359 13.3997L13.8974 13.2074ZM13.3419 11.8741L13.8034 11.6818V11.6818L13.3419 11.8741ZM10.6666 10.5535C10.3905 10.5535 10.1666 10.7774 10.1666 11.0535C10.1666 11.3297 10.3905 11.5535 10.6666 11.5535V10.5535ZM5.33332 11.5535C5.60946 11.5535 5.83332 11.3297 5.83332 11.0535C5.83332 10.7774 5.60946 10.5535 5.33332 10.5535V11.5535ZM12.1666 6.46096C12.1666 7.60762 11.5141 8.97929 10.6032 10.0884C10.1538 10.6355 9.65991 11.0957 9.18752 11.4148C8.70439 11.7413 8.2936 11.8869 7.99998 11.8869V12.8869C8.58136 12.8869 9.19141 12.6191 9.74734 12.2435C10.314 11.8606 10.8774 11.3302 11.376 10.7231C12.3609 9.52383 13.1666 7.93253 13.1666 6.46096H12.1666ZM7.99998 11.8869C7.70636 11.8869 7.29557 11.7413 6.81245 11.4148C6.34005 11.0957 5.84613 10.6355 5.39679 10.0884C4.48589 8.97929 3.83332 7.60762 3.83332 6.46096H2.83332C2.83332 7.93253 3.63908 9.52383 4.62401 10.7231C5.12258 11.3302 5.68595 11.8606 6.25262 12.2435C6.80856 12.6191 7.4186 12.8869 7.99998 12.8869V11.8869ZM3.83332 6.46096C3.83332 4.11141 5.70619 2.22021 7.99998 2.22021V1.22021C5.13912 1.22021 2.83332 3.57403 2.83332 6.46096H3.83332ZM7.99998 2.22021C10.2938 2.22021 12.1666 4.11141 12.1666 6.46096H13.1666C13.1666 3.57403 10.8608 1.22021 7.99998 1.22021V2.22021ZM9.16665 6.38688C9.16665 7.03121 8.64431 7.55355 7.99998 7.55355V8.55355C9.1966 8.55355 10.1666 7.5835 10.1666 6.38688H9.16665ZM7.99998 7.55355C7.35565 7.55355 6.83332 7.03121 6.83332 6.38688H5.83332C5.83332 7.5835 6.80336 8.55355 7.99998 8.55355V7.55355ZM6.83332 6.38688C6.83332 5.74255 7.35565 5.22021 7.99998 5.22021V4.22021C6.80336 4.22021 5.83332 5.19026 5.83332 6.38688H6.83332ZM7.99998 5.22021C8.64431 5.22021 9.16665 5.74255 9.16665 6.38688H10.1666C10.1666 5.19026 9.1966 4.22021 7.99998 4.22021V5.22021ZM2.19656 11.6818L1.64101 13.0151L2.56408 13.3997L3.11964 12.0664L2.19656 11.6818ZM3.33332 15.5535H12.6666V14.5535H3.33332V15.5535ZM14.359 13.0151L13.8034 11.6818L12.8803 12.0664L13.4359 13.3997L14.359 13.0151ZM12.1111 10.5535H10.6666V11.5535H12.1111V10.5535ZM3.88887 11.5535H5.33332V10.5535H3.88887V11.5535ZM13.8034 11.6818C13.5187 10.9986 12.8512 10.5535 12.1111 10.5535V11.5535C12.4475 11.5535 12.7509 11.7558 12.8803 12.0664L13.8034 11.6818ZM12.6666 15.5535C13.9749 15.5535 14.8621 14.2227 14.359 13.0151L13.4359 13.3997C13.6646 13.9486 13.2613 14.5535 12.6666 14.5535V15.5535ZM1.64101 13.0151C1.13784 14.2227 2.02509 15.5535 3.33332 15.5535V14.5535C2.73867 14.5535 2.33537 13.9486 2.56408 13.3997L1.64101 13.0151ZM3.11964 12.0664C3.24903 11.7558 3.55245 11.5535 3.88887 11.5535V10.5535C3.14875 10.5535 2.48122 10.9986 2.19656 11.6818L3.11964 12.0664Z"
                fill="#AFB1B9"
              />
            </svg>

            <span className="text-sm text-[#263238]">
              Dubai-United Arab Emirates
            </span>
          </div>
          <div className="flex gap-1 mt-[10px] items-center">
            <svg
              width={16}
              height={16}
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.33331 5.72021H14.6666M1.33331 4.38688V12.3869C1.33331 13.8596 2.52722 15.0535 3.99998 15.0535H12C13.4727 15.0535 14.6666 13.8596 14.6666 12.3869V4.38688C14.6666 2.91412 13.4727 1.72021 12 1.72021H3.99998C2.52722 1.72021 1.33331 2.91412 1.33331 4.38688Z"
                stroke="#AFB1B9"
                strokeLinecap="round"
              />
              <ellipse
                cx={12}
                cy="3.71989"
                rx="0.666667"
                ry="0.666667"
                fill="#AFB1B9"
              />
              <ellipse
                cx="9.33335"
                cy="3.71989"
                rx="0.666667"
                ry="0.666667"
                fill="#AFB1B9"
              />
            </svg>
            <span className=" text-sm text-[#263238]">Mon 24 Jan</span>
          </div>
          <div className="flex gap-1 mt-[10px]">
            <svg
              width={17}
              height={17}
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.99996 9.49984H8.39996C8.39996 9.7581 8.56522 9.98738 8.81022 10.069L8.99996 9.49984ZM9.59996 5.33317C9.59996 5.0018 9.33133 4.73317 8.99996 4.73317C8.66859 4.73317 8.39996 5.0018 8.39996 5.33317H9.59996ZM11.3102 10.9024C11.6246 11.0072 11.9644 10.8373 12.0692 10.5229C12.174 10.2085 12.0041 9.86875 11.6897 9.76396L11.3102 10.9024ZM9.59996 9.49984V5.33317H8.39996V9.49984H9.59996ZM8.81022 10.069L11.3102 10.9024L11.6897 9.76396L9.1897 8.93063L8.81022 10.069ZM16.7333 9.49984C16.7333 13.7708 13.271 17.2332 8.99996 17.2332V18.4332C13.9337 18.4332 17.9333 14.4336 17.9333 9.49984H16.7333ZM8.99996 17.2332C4.72896 17.2332 1.26663 13.7708 1.26663 9.49984H0.066626C0.066626 14.4336 4.06622 18.4332 8.99996 18.4332V17.2332ZM1.26663 9.49984C1.26663 5.22884 4.72896 1.7665 8.99996 1.7665V0.566504C4.06622 0.566504 0.066626 4.56609 0.066626 9.49984H1.26663ZM8.99996 1.7665C13.271 1.7665 16.7333 5.22884 16.7333 9.49984H17.9333C17.9333 4.56609 13.9337 0.566504 8.99996 0.566504V1.7665Z"
                fill="#A5AFC0"
              />
            </svg>

            <span className=" text-sm text-[#A5AFC0]">
              Show starts
              <span className="text-[#263238] text-sm ml-[10px]">21:00</span>
            </span>
          </div>
          <NavLink
            to={"/events/title/survey"}
            className="mt-[22px] border-[2px] border-[#6D9AFF] border-dashed px-[20px] xs:px-[40px] sm:px-[92px] py-[15px] sm:py-[20px] rounded-[10px] flex justify-center items-center gap-[14px] "
          >
            <TicketIcon />
            <h6 className="text-[#2E3E8D]">Download Tickets</h6>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default EventBookingConfirmation;
